export default __webpack_public_path__ + "eb64b0c6ccc46c61d25182c008a6bbce662b962e/161a231856ba99f96b16b1f91115e718.png";